module.exports = __webpack_public_path__ + "img/motoras.d2d033fc.png";